import { UserX } from 'lucide-react';
import { cn } from '@/lib/utils';
import { STATUS_COLOR_CLASS } from '@/styles/statusColors';
import { TEACHER_INACTIVATION_REASON_LABELS } from '../constants/teacherInactivation.constants';
import type { TeacherInactivationRequest } from '../types/teacherInactivation.types';

const REQUEST_TITLE = 'Make this teacher inactive';

interface TeacherInactivationRequestSectionProps {
  request: TeacherInactivationRequest;
}

export function TeacherInactivationRequestSection({
  request,
}: TeacherInactivationRequestSectionProps) {
  return (
    <section
      className={cn(
        'flex items-start gap-2 rounded-lg px-3 py-2 text-sm',
        STATUS_COLOR_CLASS.warning,
      )}
    >
      <UserX className="mt-0.5 size-4 shrink-0" aria-hidden />
      <div className="flex min-w-0 flex-col gap-0.5">
        <p>
          <span className="font-semibold">{REQUEST_TITLE}</span>
          <span className="font-medium">
            {' '}
            · {TEACHER_INACTIVATION_REASON_LABELS[request.reasonCode]}
          </span>
        </p>
        <p className="mt-1 rounded-md bg-card/70 px-2.5 py-1.5 whitespace-pre-line text-foreground wrap-break-word">
          {request.reasonComment}
        </p>
      </div>
    </section>
  );
}
